import { Injectable } from '@angular/core';
import { UserTokenRequest } from '../models/user-token-request.model';
import { UserTokenAPIService } from '../../../shared/services/API/User-Token.service';

@Injectable({
  providedIn: 'root'
})
export class UserTokenService {

  constructor(private userTokenService: UserTokenAPIService) {}

  isValidToken(userToken: UserTokenRequest){
    return this.userTokenService.isValidToken(userToken);
  }
}